<div class="app-container">
  <wl-header class="app-header-container"></wl-header>
  <div *ngFor="let s of sizes" class="invisible {{ s.css + ' ' + (prefix + s.id) }}"></div>
  <main class="app-main-container application-feature-modules">
    <div class="app-wrapper h-full">
      <div class="app-view-container dashboard">
        <div class="main-actions">
          <wl-jackpot-assets-actions
            *ngIf="assets.length"
            [assetCount]="assets.length"
            [assets]="assets"
            [gridSettingsKeySuffix]="gridSettingsKeySuffix"
            [selectedViewSection2]="selectedViewSection2"
            (changeView)="changeAssetView($event)"
            (sortBy)="sortBy($event)"
            (tabSelected)="toggleFilterTabs($event.link)"
            [selectedTabKey]="selectedTabKey"
            (searchTextChanged)="searchTextChanged($event)"
            (clearSearch)="clearSearch($event)"
            [searchText]="searchText"
            (applyFilters)="filterAssets('', $event)"
            [appliedFilters]="appliedFilters"
          ></wl-jackpot-assets-actions>
        </div>
        <div class="app-content-header">
          <h2>
            Jackpot Assets
            <span *ngIf="info">
              | Klasse 1: {{ info.klasse1 | number : '1.0-0' }} | Klasse 2: {{ info.klasse2 | number : '1.0-0' }} | Annahmeschluss: {{ info.annahmeschluss | date : "dd.MM.yyyy 'um' HH:mm 'Uhr'" }}
            </span>
          </h2>
        </div>
        <div class="app-content-container">
          <thehubz-asset-gallery-view
            *ngIf="assets.length"
            [configObject]="configObject"
            [imageObject]="imageObject"
            [imageSplitObject]="imageSplitObject"
            [currentSize]="currentSize"
            [filterObject]="filterObject"
            [itemSize]="itemSize"
            [assetCount]="imageObject.length"
            [offset]="offset"
            [gridSettingsKeySuffix]="gridSettingsKeySuffix"
            [size]="size"
            (downloadAsset)="downloadFormat($event.asset)"
            [enableAssetDetailsLink]="false"
            (viewAsset)="openAssetPreview($event)"
          >
          </thehubz-asset-gallery-view>
          <sp-blank-page *ngIf="!assets.length" pageType="assets"></sp-blank-page>
        </div>
      </div>
    </div>
  </main>
  <div class="app-footer-container">
    <div class="footer-content">
      <sp-footer></sp-footer>
    </div>
  </div>
</div>
